var React = require('react');

function OutOfStok (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","key":0}),React.createElement("path",{"d":"M20.76 7.83L15 13.59 9.24 7.83 7.83 9.24 13.59 15l-5.76 5.76 1.41 1.41L15 16.41l5.76 5.76 1.41-1.41L16.41 15l5.76-5.76-1.41-1.41z","fillRule":"evenodd","key":1})]);
}

OutOfStok.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = OutOfStok;

OutOfStok.default = OutOfStok;
